import React from "react";
import Reveal from "./Reveal";
import { trackEvent } from "../../lib/track";

/**
 * Clarity Reset Session Bridge.
 *
 * Concise homepage placement of the $149 Clarity Reset Session,
 * framed around the visitor who keeps circling the same decision.
 * Opens the Stripe modal via the existing global event so visitors
 * land directly in checkout without leaving the page. Visitors who
 * are not ready for a paid session get a quiet free-Snapshot exit.
 */
const OrientationResetBridge = () => {
  const openCheckout = () => {
    trackEvent("orientation_reset_bridge_cta_clicked");
    window.dispatchEvent(new CustomEvent("am:open-orientation-reset-checkout"));
  };

  return (
    <section
      id="orientation-reset-bridge"
      data-testid="orientation-reset-bridge-section"
      className="relative py-24 md:py-32 border-t border-gold/10"
    >
      <div className="max-w-3xl mx-auto px-6 md:px-10 text-center">
        <Reveal>
          <p className="text-[11px] tracking-[0.5em] uppercase text-gold mb-6">
            The Bridge
          </p>
          <h2 className="font-serif text-3xl sm:text-4xl md:text-5xl leading-tight tracking-tight text-themed font-light">
            You have been circling this{" "}
            <span className="italic gold-gradient-text">long enough.</span>
          </h2>
        </Reveal>
        <Reveal delay={120}>
          <p
            data-testid="orientation-reset-bridge-copy"
            className="mt-8 text-themed-muted text-base md:text-lg leading-relaxed max-w-2xl mx-auto"
          >
            You have been thinking about the same decision, pattern, project, or next move for too long. The Clarity Reset Session gives you a focused space to name what is happening, see the pattern, and leave with a practical next step.
          </p>
        </Reveal>
        <Reveal delay={220}>
          <button
            type="button"
            data-testid="orientation-reset-bridge-cta"
            onClick={openCheckout}
            className="btn-gold mt-10"
          >
            Book the Clarity Reset Session · $149
          </button>
          <p className="mt-5 text-[12px] tracking-[0.18em] uppercase text-gold/70">
            <a
              href="/frequency-snapshot"
              data-testid="orientation-reset-bridge-snapshot-link"
              className="hover:text-gold transition-colors"
            >
              If you are not ready for a paid session, take the free Clarity Snapshot first.
            </a>
          </p>
        </Reveal>
      </div>
    </section>
  );
};

export default OrientationResetBridge;
